package feature.businessType.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BusinessTypeRequest(
    @SerialName("BusinessID") val businessID: String,
)